<app-top-header *ngIf="!isUserLoggedIn"></app-top-header>
<app-home-custom-top-header *ngIf="isUserLoggedIn"></app-home-custom-top-header>
<app-comman-header></app-comman-header>
<div class="main" style="background-image: url(../../../assets/media/bg/bg-10.jpg)"></div>

<div class="col-lg-12">
    <div class="card card-custom gutter-b card-stretch p-4 p-sm-10" style="top: 30px">
        <div class="card-body">
            <div class="container">
                <div class="card-main">
                    <div class="card-space">
                        <div class="card-1">
                            <h2>404</h2>
                            <p>THE WEB PAGE YOU</p>
                            <p>REQUESTED CANNOT BE FOUND</p>
                        </div>
                        <div class="error-wrapper">
                            <h4><b>WHOOPS, SOMETHING GOT</b></h4>
                            <h3>DISCONNECTED</h3>
                            <p>[PLAESE, HEAD BACK TO THE HOME PAGE]</p>
                        </div>
                    </div>
                </div>
                <div>
                    <br />
                    <div class="row" style="display: flex; justify-content: center">
                        <div class="read_more mt-0 mt-sm-10">
                            <button (click)="backurl()" class="btn primary-ebtn py-3">
                                <i class="fa fa-share-square" aria-hidden="true"></i>
                                back
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>